module.exports = (arr, callback) => {
  return arr.flatMap(callback)
}
